var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroundtruthLogoTextWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 8,
    viewBox: "0 0 60 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3668 2.25195C12.7703 2.25195 11.6566 3.47026 11.6566 4.94499C11.6566 6.41972 12.7703 7.62663 14.3668 7.62663C15.9634 7.62663 17.0881 6.39807 17.0881 4.94499C17.0881 3.49191 15.9743 2.25195 14.3668 2.25195ZM14.3767 6.14278C13.7655 6.14278 13.3222 5.62082 13.3222 4.94499C13.3222 4.26917 13.7655 3.73694 14.3767 3.73694C14.9879 3.73694 15.4323 4.25891 15.4323 4.94499C15.4323 5.63107 14.989 6.14278 14.3767 6.14278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.73093 4.80257H5.62373C5.41634 5.53993 4.84466 6.01062 3.96794 6.01062C2.74558 6.01062 1.95664 5.07951 1.95664 3.82017C1.95664 2.56084 2.80374 1.61947 3.93832 1.61947C4.6285 1.61947 5.20018 1.99784 5.56447 2.57109L6.86584 1.42459C6.1954 0.542483 5.1903 0 3.93832 0C1.88752 0 0.19223 1.65822 0.19223 3.81903C0.19223 5.97985 1.84801 7.62781 3.86919 7.62781C5.89036 7.62781 7.43752 6.01973 7.43752 3.90109V3.33809H3.73093V4.80257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.9132 5.46691C20.9132 5.87606 20.6081 6.16325 20.2032 6.16325C19.7984 6.16325 19.4933 5.8772 19.4933 5.46691V2.40576H17.719V5.41563C17.719 6.89036 18.9216 7.62659 20.2032 7.62659C21.4849 7.62659 22.6875 6.88922 22.6875 5.41563V2.40576H20.9132V5.46691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.74402 3.30726V2.40578H8.11786V7.47389H9.89215V4.98599C9.89215 4.22811 10.3168 3.96143 10.77 3.96143C10.9576 3.96143 11.1244 4.00246 11.2725 4.07426H11.312V2.40578C11.1836 2.36475 11.0366 2.34424 10.8983 2.34424C10.3662 2.34424 9.98212 2.71235 9.74511 3.30726H9.74402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.9294 3.07136C32.5947 2.59954 32.102 2.32374 31.4206 2.32374C30.2477 2.32374 29.1932 3.26625 29.1932 4.93472C29.1932 6.6032 30.2685 7.56508 31.4009 7.56508C32.18 7.56508 32.722 7.19697 33.0468 6.61346V7.47277H34.7026V0.153809H32.9283V3.07136H32.9294ZM31.9638 6.14277C31.3526 6.14277 30.9477 5.6208 30.9477 4.93472C30.9477 4.29993 31.3515 3.73693 31.9638 3.73693C32.5761 3.73693 32.9886 4.29993 32.9886 4.93472C32.9886 5.6208 32.5651 6.14277 31.9638 6.14277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M52.5749 1.12598H50.8006V2.40583H50.1006V3.7985H50.8006V5.6516C50.8006 6.95197 51.4513 7.57651 52.9491 7.57651C53.1949 7.57651 53.4023 7.53548 53.6195 7.47394V6.05049C53.4813 6.10177 53.275 6.13254 53.1664 6.13254C52.7626 6.13254 52.5749 5.9274 52.5749 5.5798V3.7985H53.6195V2.40583H52.5749V1.12598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M47.7151 5.46691C47.7151 5.87606 47.4101 6.16325 47.0052 6.16325C46.6003 6.16325 46.2963 5.8772 46.2963 5.46691V2.40576H44.522V5.41563C44.522 6.89036 45.7246 7.62659 47.0063 7.62659C48.2879 7.62659 49.4905 6.88922 49.4905 5.41563V2.40576H47.7162V5.46691H47.7151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M57.5433 2.2622C56.9025 2.2622 56.3999 2.54825 56.0839 3.01894V0.153809H54.3096V7.47391H56.0839V4.37173C56.0839 3.92156 56.3988 3.65487 56.8026 3.65487C57.2064 3.65487 57.5323 3.92042 57.5323 4.37173V7.47391H59.3066V4.26916C59.3066 3.1329 58.567 2.2622 57.5422 2.2622H57.5433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M42.2946 3.30726V2.40578H40.6684V7.47389H42.4427V4.98599C42.4427 4.22811 42.8662 3.96143 43.3194 3.96143C43.507 3.96143 43.6738 4.00246 43.8231 4.07426H43.8626V2.40578C43.7342 2.36475 43.586 2.34424 43.4478 2.34424C42.9156 2.34424 42.5316 2.71235 42.2946 3.30726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M26.778 2.26221C26.0384 2.26221 25.4865 2.65083 25.1913 3.24574V2.40581H23.5454V7.47392H25.3197V4.37174C25.3197 3.92157 25.6346 3.65488 26.0384 3.65488C26.4422 3.65488 26.7681 3.92043 26.7681 4.37174V7.47392H28.5424V4.26917C28.5424 3.13291 27.8028 2.26221 26.778 2.26221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40.6969 0.153809H35.4629V1.72997H37.1385V7.47391H38.9621V1.72997H40.6969V0.153809Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundtruthLogoTextWhite);
export default __webpack_public_path__ + "static/media/groundtruth-logo-text-white.b1dd7b2a87e34b28f48dea1463003752.svg";
export { ForwardRef as ReactComponent };